var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.6,81.6c-0.9,11.2-1.9,22.3-2.2,33.5c-0.3,12.9,3.1,24.6,8.6,36c2.3,4.8,5.2,9.2,6.6,14.5 c1.9,7,1.3,8.9-5.1,11.5c-2.3,1-4.7,1.9-7,3c-4.1,2.1-5.1,4.7-3.5,9c1,2.7,2.7,5.3,3.3,8c0.5,2.3,0.6,4.6-2.8,6.1 c-6.1,2.7-12.4,1.4-18.6,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.1,205.6c3.7,4.9,3.9,8.8-0.6,11.9c-6.7,4.5-5.1,10.6-4.4,16.6c1.3,10-3.5,21.1-14.5,24 c-8.5,2.3-16.7-0.5-25-1.4c-4.3-0.5-8.2-3.1-13-1.7c-4.2,1.2-6,4-5.9,7.6c0.4,15.7-1.2,31.4,0.9,47c1.5,11.4,7,20.8,14,29.5 c1.2,1.5,2.3,3,3.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,82.6c0,6.3-0.2,12.7,0,19c1,26.7,7.6,51.9,21.4,75c8.8,14.7,17.8,29.4,24,45.5 c4.4,11.4,6.5,23.3,5.4,35.5c-0.8,9.7-4,19.1-6.4,28.5c-2.3,8.9-5,17.7-7.5,26.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7684022dd887232279e872979f574743.svg";
export { ForwardRef as ReactComponent };